const Routes = {
    "products.calendars.create": {
        path: "/sections/cardscalendars/create.php?template=:templateUuid&medium=:productUuid",
        component: 'a',
        protected: false,
    },
    "products.categories.category.create": {
        path: "/sections/cardscalendars/create.php?template=:templateUuid&medium=:productUuid",
        component: 'a',
        protected: false,
    },
    "products.cards.category": {
        path: '/sections/cardscalendars/cardsv2/?category=:category',
        linkComponent: 'a',
        protected: false
    },
};
// We add this as a hook so we can implement localization later:
const useDesktopRoutes = () => {
    return Routes;
};
export default useDesktopRoutes;
